import { Group, Stack, Text, Title, type TitleOrder } from "@mantine/core";
import type { ReactNode } from "react";

export interface PageHeaderProps {
  /** Page title, rendered as the page's h1 unless `order` says otherwise. */
  readonly title: string;
  readonly description?: string;
  /** Actions pinned to the right on wide screens, stacked under the title on phones. */
  readonly actions?: ReactNode;
  /** Breadcrumbs or other context above the title. */
  readonly above?: ReactNode;
  readonly order?: TitleOrder;
}

/** Consistent page heading: hierarchy through size, weight, and placement; no eyebrow labels. */
export function PageHeader({ title, description, actions, above, order = 1 }: PageHeaderProps) {
  return (
    <Stack gap="xs" mb="lg">
      {above}
      <Group justify="space-between" align="flex-start" wrap="wrap" gap="md">
        <Stack gap={4} style={{ flex: "1 1 320px", minWidth: 0 }}>
          <Title order={order}>{title}</Title>
          {description !== undefined && (
            <Text c="dimmed" size="sm">
              {description}
            </Text>
          )}
        </Stack>
        {actions !== undefined && (
          <Group gap="sm" wrap="wrap" style={{ flexShrink: 0, maxWidth: "100%" }}>
            {actions}
          </Group>
        )}
      </Group>
    </Stack>
  );
}
